<template>
  <div id="app">
    <!--<Header :affix="affix"></Header>-->
    <Loader  v-bind:logo="loaderLogo"></Loader>

    <div class="main">
      <transition name="fade-in-up">
        <router-view/>
      </transition>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/common/MainHeader'
import Footer from './components/common/MainFooter'
import Loader from './components/common/Loader'

export default {
  name: 'App',
  components: {Header, Loader, Footer},
  data(){
    return{
      affix:''
    }
  },
  methods: {
    handleScroll: function (evt, el) {
      if (window.scrollY > 100) {
        this.affix = 'affix';
      } else {
        this.affix = '';
      }
    }
  },
  computed: {
    loaderLogo() {
      return ''
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue